import { ParametrizacaoVO } from "./parametrizacao-vo.model";
import { Parametrizacao } from ".";

export class ParametroVO {
    idRegiao: number;
    parametrizacao: Parametrizacao[];

    constructor(init?: Partial<ParametrizacaoVO>) {
      Object.assign(this, init);
    }

}
